// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  font-family: Arial, sans-serif;
  background-image: linear-gradient(135deg, #3498db, #2c3e50);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
}

.login-container {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  width: 400px;
  padding: 40px;
  text-align: center;
}

.logo {
  margin-bottom: 30px;
}

.logo img {
  max-width: 150px;
}

.login-form {
  text-align: left;
}

.error-message {
  background-color: #ffebee;
  color: #c62828;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
  font-size: 14px;
}

.success-message {
  background-color: #e8f5e9;
  color: #2e7d32;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
  font-size: 14px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  color: #7f8c8d;
  font-size: 14px;
}

.form-input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
}

.login-button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 12px;
  width: 100%;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
}

.login-button:hover {
  background-color: #2980b9;
}

.forgot-password {
  margin-top: 15px;
  font-size: 14px;
  color: #7f8c8d;
  text-align: center;
}

.forgot-password a {
  color: #3498db;
  text-decoration: none;
}

.forgot-password a:hover {
  text-decoration: underline;
}

.register-link {
  margin-top: 20px;
  font-size: 14px;
  color: #7f8c8d;
  text-align: center;
}

.register-link a {
  color: #3498db;
  text-decoration: none;
}

.register-link a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,2DAA2D;EAC3D,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".login-page {\n  font-family: Arial, sans-serif;\n  background-image: linear-gradient(135deg, #3498db, #2c3e50);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100vw;\n}\n\n.login-container {\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);\n  width: 400px;\n  padding: 40px;\n  text-align: center;\n}\n\n.logo {\n  margin-bottom: 30px;\n}\n\n.logo img {\n  max-width: 150px;\n}\n\n.login-form {\n  text-align: left;\n}\n\n.error-message {\n  background-color: #ffebee;\n  color: #c62828;\n  padding: 10px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.success-message {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n  padding: 10px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 8px;\n  color: #7f8c8d;\n  font-size: 14px;\n}\n\n.form-input {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.login-button {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 12px;\n  width: 100%;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  margin-top: 10px;\n}\n\n.login-button:hover {\n  background-color: #2980b9;\n}\n\n.forgot-password {\n  margin-top: 15px;\n  font-size: 14px;\n  color: #7f8c8d;\n  text-align: center;\n}\n\n.forgot-password a {\n  color: #3498db;\n  text-decoration: none;\n}\n\n.forgot-password a:hover {\n  text-decoration: underline;\n}\n\n.register-link {\n  margin-top: 20px;\n  font-size: 14px;\n  color: #7f8c8d;\n  text-align: center;\n}\n\n.register-link a {\n  color: #3498db;\n  text-decoration: none;\n}\n\n.register-link a:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
